import './home.scss'

// import GlowingBlob from '../components/blob/GlowingBlob'

import { motion } from 'framer-motion'
import { createAnimation } from '../../config/config'

const Home = () => {
  return (
    <div className="page-section home-section">
      <div className="hero">
        <motion.h1 className="hero-heading" {...createAnimation(-300, 1.5)}>
          <span className="gradient-text"> Stina Nerin</span>
        </motion.h1>
        <motion.p className="main-paragraph" {...createAnimation(-200, 1.5)}>
          <span className="gradient-text">Frontend Developer</span> interested
          about the <span className="gradient-text">logic</span> in{' '}
          <span className="gradient-text">pixels</span>
        </motion.p>
        <motion.p className="sub-paragraph" {...createAnimation(-100, 1.5)}>
          I enjoy creating <span className="gradient-text">delightful</span> and{' '}
          <span className="gradient-text">accessible</span> digital experiences
          with code, from the user interface to the server logic.
        </motion.p>
      </div>
      {
        // <GlowingBlob position={{ top: '20%', left: '50%' }} />
      }
      {/*  <div class="scribble"></div> */}
    </div>
  )
}

export default Home
